<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-tab
        :tabItems="tabItems"
        @itemClick="tabTtemClickHandler"
      ></c-tab>
      <c-content>
        <!--手机充值-->
        <template v-if="currentTab==='phone'">
          <c-number-input
            :formater="formater"
            inputType="tel"
            v-model="inputNum"
            placeholder="请输入手机号"
          ></c-number-input>
          <!--话费-->
          <template v-if="rechargePhone.length > 0">
            <c-title-line
              title="充话费"
              :no-border="true"
            ></c-title-line>
            <c-footer class="no-border">
              <c-button-recharge
                v-for="item in rechargePhone"
                :key="item.id"
                :title="item.title"
                :desc="item.desc"
                :commend="item.commend"
                :disabled="item.isDisable"
                @click.native="rechargeItemClick(item)"
              ></c-button-recharge>
            </c-footer>
          </template>
          <!--流量-->
          <template v-if="rechargePhoneData.length > 0">
            <c-title-line
              title="充流量"
              :no-border="true"
            ></c-title-line>
            <c-footer class="no-border">
              <c-button-recharge
                v-for="item in rechargePhoneData"
                :key="item.id"
                v-if="item.isVisable"
                :title="item.title"
                :desc="item.desc"
                :commend="item.commend"
                :disabled="item.isDisable"
                @click.native="rechargeItemClick(item)"
              ></c-button-recharge>
            </c-footer>
          </template>
        </template>
        <!--Q币充值-->
        <template v-if="currentTab==='qq'">
          <c-number-input
            inputType="tel"
            v-model="inputNum"
            placeholder="请输入QQ号"
          ></c-number-input>
          <template v-if="rechargeQQ.length > 0">
            <c-title-line
              title="充Q币"
              :no-border="true"
            ></c-title-line>
            <c-footer class="no-border">
              <c-button-recharge
                v-for="item in rechargeQQ"
                :key="item.id"
                :title="item.title"
                :desc="item.desc"
                :commend="item.commend"
                :disabled="item.isDisable"
                @click.native="rechargeItemClick(item)"
              ></c-button-recharge>
            </c-footer>
          </template>
        </template>
      </c-content>
    </c-page>
    <transition
      name="slide-right"
      mode="out-in"
    >
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
@import "index";
@import "../../../../assets/scss/base/_variables";

.c-page {
  background-color: $main-backgroud-gray !important;
}

.no-border {
  border: none;
  background-color: $panel-title-bg-color;
}
</style>
<script>
import CButtonRecharge from '../../../../components/c-button/recharge/index'
import RechargeObj from '../../../../model/rechage/phone/index'
import Pay from '../../../../model/pay'
import debounce from 'lodash.debounce'
export default {
  data () {
    return {
      currentTab: 'phone',
      inputNum: '',
      tabItems: [{
        name: '手机充值',
        select: true,
        tabName: 'phone'
      }],
      rechargePhone: [],
      rechargePhoneData: [],
      rechargeQQ: [],
      rechargeObj: new RechargeObj(),
      pay: new Pay()
    }
  },
  components: { CButtonRecharge },
  created () { },
  mounted () {
    this.rechargeObj.loadData().then(res => {
      let data = res
      this.rechargePhone = data.rechargePhone
      this.rechargePhoneData = data.rechargePhoneData
      this.rechargeQQ = data.rechargeQQ
    })
  },
  beforeDestroy () { },
  methods: {
    tabTtemClickHandler (itemObj) {
      this.inputNum = ''
      this.currentTab = itemObj.tabName
      for (let item of this.tabItems) {
        item.select = item === itemObj
      }
    },
    rechargeItemClick: debounce(function (itemObj) {
      if (itemObj.isDisable) return
      this.pay.rechargePay(itemObj.id, this.realNum)
    }, 330),
    chargePhoneWork (disabled) {
      if (disabled) {
        for (let arrItem of [this.rechargePhone, this.rechargePhoneData]) {
          for (let item of arrItem) {
            item.isDisable = disabled
            item.isVisable = true
          }
        }
      } else {
        if (this.realNum.length !== 11) return
        this.rechargeObj.checkPhone(this.realNum).then((res) => {
          if (!res.canCharge) this.$wejs.topTips(res.reason)
          for (let item of this.rechargePhone) {
            item.isDisable = !res.canCharge
          }
          for (let item of this.rechargePhoneData) {
            item.isVisable = res.rechargeDataArr.includes(item.title.replace(/m|M/, ''))
            item.isDisable = false
          }
        })
      }
    },
    changeQQWork (disabled) {
      for (let item of this.rechargeQQ) {
        item.isDisable = disabled
      }
    },
    formater (val) {
      let phone = val.replace(/-/g, '').split('')
      if (phone[3] !== undefined) phone.splice(3, 0, '-')
      if (phone[8] !== undefined) phone.splice(8, 0, '-')
      return phone.join('')
    }
  },
  computed: {
    realNum () {
      return this.inputNum.replace(/-/g, '')
    }
  },
  watch: {
    realNum (val) {
      if (this.currentTab === 'phone') {
        this.chargePhoneWork(val.length !== 11)
      } else {
        this.changeQQWork(!(val.length > 4))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?3808c498